import {
  getAuthToken,
  setAuthToken,
  removeAuthToken
} from './auth'

import * as currentUserId from './currentUserId'
import * as user from './user'

export {
  getAuthToken,
  setAuthToken,
  removeAuthToken,
  currentUserId,
  user
}



// WEBPACK FOOTER //
// ./src/shared/utils/auth/index.js